exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plans-table{font-size:13px}.plans-table th{background:#d8e2f2;color:#555}.plans-table td,.plans-table th{text-align:center;vertical-align:middle!important}.plans-table td{padding:5px 10px}.plans-table .form-control{font-size:12px;height:auto;padding:2px 6px}.plans-table textarea.form-control{min-width:200px;resize:vertical}.plan-add-form .btn,.plan-add-form .form-control,.plan-add-form label{font-size:12px}.plan-add-form .form-control{height:30px!important;padding:4px 8px;line-height:1.5}.plan-add-form .btn{padding:4px 8px}.plans-table .btn-sm{font-size:12px;padding:2px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d74af2ac","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/manual-forms/plans.vue
// module id = 760
// module chunks = 27